<template>
  <div class="hide">
    <svg>
    </svg>
  </div>
</template>

<script>
export default {

}
</script>
